import { render } from "./GrupoResultadoDRE.vue?vue&type=template&id=05aa78c8&scoped=true&ts=true"
import script from "./GrupoResultadoDRE.vue?vue&type=script&lang=ts"
export * from "./GrupoResultadoDRE.vue?vue&type=script&lang=ts"

import "./GrupoResultadoDRE.vue?vue&type=style&index=0&id=05aa78c8&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aa78c8"]])

export default __exports__